import { render, staticRenderFns } from "./TradesTableModern.vue?vue&type=template&id=4f5cd5fe&"
import script from "./TradesTableModern.vue?vue&type=script&lang=js&"
export * from "./TradesTableModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports